module.exports = __webpack_public_path__ + "static/media/About_1.c1abd8b8.mp4";